import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from '@emotion/styled';
export var FormSection = styled.section(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-rows: auto;\n  grid-template-columns: auto;\n\n  text-align: left;\n\n  & > * {\n    grid-area: 1/1;\n  }\n"])));